import { useCallback, useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  InputGroup,
  Row,
  Spinner,
  Table,
} from "react-bootstrap";
import { Redirect } from "react-router-dom";
import { FaPlus, FaTrash } from "react-icons/fa";
import SidebarPanelNavigation from "../../../../components/SidebarPanelNavigation";
import useAuth from "../../../../contexts/auth";
import {
  listWhatsAppWebBlacklist,
  addWhatsAppWebBlacklist,
  removeWhatsAppWebBlacklist,
} from "../../../../services/api";

export default function BlacklistPage() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [phone, setPhone] = useState("");
  const [reason, setReason] = useState("");
  const [search, setSearch] = useState("");
  const [adding, setAdding] = useState(false);

  const reload = useCallback(async () => {
    setLoading(true);
    try {
      const res = await listWhatsAppWebBlacklist();
      setItems(res?.data || []);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  if (!user) return <Redirect to="/entrar" />;
  if (user.type !== "admin") return <Redirect to="/" />;

  async function handleAdd(e) {
    e.preventDefault();
    if (!phone.trim()) return;
    setAdding(true);
    try {
      await addWhatsAppWebBlacklist(phone.trim(), reason.trim() || null);
      setPhone("");
      setReason("");
      reload();
    } catch (err) {
      alert("Número inválido (mínimo 10 dígitos).");
    } finally {
      setAdding(false);
    }
  }

  async function handleRemove(id) {
    if (!window.confirm("Remover número da blacklist?")) return;
    await removeWhatsAppWebBlacklist(id);
    reload();
  }

  const filtered = search
    ? items.filter((i) => i.phone.includes(search))
    : items;

  return (
    <Container fluid className="p-4">
      <Row>
        <Col md={3} lg={2}>
          <SidebarPanelNavigation isAdmin />
        </Col>
        <Col md={9} lg={10}>
          <h2 className="mb-1">🚫 Blacklist</h2>
          <p className="text-muted">
            Números que NÃO devem receber campanhas (LGPD/opt-out)
          </p>

          <Card className="mb-3">
            <Card.Body>
              <Form onSubmit={handleAdd}>
                <Row>
                  <Col md={4}>
                    <Form.Label>Número (E.164)</Form.Label>
                    <Form.Control
                      placeholder="5588XXXXXXXXX"
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                    />
                  </Col>
                  <Col md={6}>
                    <Form.Label>Motivo (opcional)</Form.Label>
                    <Form.Control
                      placeholder="Ex: solicitou opt-out"
                      value={reason}
                      onChange={(e) => setReason(e.target.value)}
                    />
                  </Col>
                  <Col md={2} className="d-flex align-items-end">
                    <Button
                      type="submit"
                      variant="primary"
                      className="w-100"
                      disabled={adding}
                    >
                      <FaPlus /> Bloquear
                    </Button>
                  </Col>
                </Row>
              </Form>
            </Card.Body>
          </Card>

          <InputGroup className="mb-3">
            <Form.Control
              placeholder="Buscar por número..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </InputGroup>

          {loading ? (
            <div className="text-center p-5">
              <Spinner animation="border" />
            </div>
          ) : filtered.length === 0 ? (
            <Card className="text-center p-4">
              <Card.Body>
                <p className="mb-0 text-muted">
                  Nenhum número{search ? " encontrado" : " bloqueado"}.
                </p>
              </Card.Body>
            </Card>
          ) : (
            <Table striped responsive>
              <thead>
                <tr>
                  <th>Número</th>
                  <th>Motivo</th>
                  <th>Bloqueado em</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {filtered.map((i) => (
                  <tr key={i.id}>
                    <td>{i.phone}</td>
                    <td>{i.reason || "—"}</td>
                    <td>
                      {new Date(i.created_at).toLocaleString("pt-BR")}
                    </td>
                    <td>
                      <Button
                        size="sm"
                        variant="outline-danger"
                        onClick={() => handleRemove(i.id)}
                      >
                        <FaTrash />
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </Col>
      </Row>
    </Container>
  );
}
